import { render } from "./AdminContent.vue?vue&type=template&id=94ded1e4&scoped=true"
import script from "./AdminContent.vue?vue&type=script&lang=js"
export * from "./AdminContent.vue?vue&type=script&lang=js"

import "./AdminContent.vue?vue&type=style&index=0&id=94ded1e4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ded1e4"]])

export default __exports__